import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../../../admin_resources/css/admin_layout.css";
import "../../../admin_resources/css/admin_common.css";
import "../../../admin_resources/css/admin_style.css";
import ADMIN_HEADER from "../Admin_Header";
import ADMIN_FOOTER from "../Admin_Footer";
import axios from "axios";

const Admin_Social = () => {
  const navigate = useNavigate();
  const [social, setSocial] = useState([]);
  const [allSocial, setAllSocial] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;
  const [searchTerm, setSearchTerm] = useState("");
  const [searchOption, setSearchOption] = useState("title");
  const [selectedSocial, setSelectedSocial] = useState([]);
  
  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    const titleElement = document.getElementsByTagName("title")[0];
    titleElement.innerHTML = `아소비 관리자 페이지`;

    // 처음 데이터 로딩
    const fetchSocial = async () => {
      try {
        const response = await axios.get("/boards");
        const filteredSocial = response.data.filter(
          (social) => social.gubun === "BB07"
        );

        const sortedSocial = filteredSocial.sort((a, b) => {
          return new Date(b.regDate) - new Date(a.regDate);
        });

        setSocial(sortedSocial);
        setAllSocial(sortedSocial);
      } catch (error) {
        console.error("Error fetching social:", error);
      }
    };

    fetchSocial();

	  // 관리자 권한 정보 가져오기
	  const adminId = localStorage.getItem("adminId");
	  if (adminId) {
	    fetchPermissions(adminId);
	  }
	}, []);

	const fetchPermissions = async (adminId) => {
	  try {
	    const response = await fetch(`/permissions/${adminId}`); // 권한 확인 API 호출
	    const data = await response.json();
	    setPermissions(data); // 권한 정보를 상태로 설정
	  } catch (error) {
	    console.error("권한 정보를 가져오는 데 실패했습니다.", error);
	  }
	};

  const formatDate = (dateString) => {
    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    };
    const date = new Date(dateString);
    return date.toLocaleString("ko-KR", options).replace(",", "");
  };

  const indexOfLastSocial = currentPage * itemsPerPage;
  const indexOfFirstSocial = indexOfLastSocial - itemsPerPage;
  const currentSocial = social.slice(indexOfFirstSocial, indexOfLastSocial);
  const totalPages = Math.ceil(social.length / itemsPerPage);

  // 페이지 범위 설정
  const pageRange = 10; // 최대 페이지 번호 개수
  const startPage = Math.floor((currentPage - 1) / pageRange) * pageRange + 1;
  const endPage = Math.min(startPage + pageRange - 1, totalPages);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  // 검색어 변경 처리
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  // 검색 기준 변경 처리
  const handleSearchOptionChange = (event) => {
    setSearchOption(event.target.value);
  };

  // 검색 버튼 클릭 처리
  const handleSearchClick = async (e) => {
    e.preventDefault();

    if (searchTerm.trim() === "") {
      setSocial(allSocial);
    } else {
      // 검색어가 있을 경우, 검색 기준에 맞춰서 필터링
      const filteredSocial = allSocial.filter((social) => {
        if (searchOption === "title") {
          // 제목을 기준으로 검색
          return social.title.toLowerCase().includes(searchTerm.toLowerCase());
        } else if (searchOption === "writer_id") {
          // 작성자를 기준으로 검색
          return social.name.toLowerCase().includes(searchTerm.toLowerCase());
        }
        return false;
      });
      setSocial(filteredSocial); // 필터링된 배너로 업데이트
    }
  };

  // 체크박스 선택 처리
  const handleCheckboxChange = (socialIdx, isChecked) => {
    // 체크박스가 선택되었을 때 idx를 콘솔에 출력
    console.log("선택된 idx:", socialIdx);
    console.log("체크박스 상태:", isChecked);

    if (isChecked) {
      // 체크박스를 선택하면 해당 팝업의 idx를 setSelectedSocial 추가
      setSelectedSocial((prevSelected) => [...prevSelected, socialIdx]);
    } else {
      // 체크박스를 선택 해제하면 해당 팝업의 idx를 setSelectedSocial 제거
      setSelectedSocial((prevSelected) =>
        prevSelected.filter((idx) => idx !== socialIdx)
      );
    }
  };

  // 선택 삭제 처리
  const handleDeleteSelected = async () => {
    try {
      if (selectedSocial.length === 0) {
        alert("삭제할 항목을 선택해주세요.");
        return;
      }

      // 삭제 확인
      const confirmation = window.confirm(`선택된 항목을 삭제 하시겠습니까?`);
      if (!confirmation) {
        return;
      }

      // 서버에 선택된 팝업 삭제 요청
      const response = await axios.post("/deleteboards", {
        ids: selectedSocial, // 서버에서 "ids"로 받는다
      });
      console.log("서버 응답:", response.data); // 응답 데이터 확인

      if (response.data.success) {
        // 삭제 후, 선택된 팝업을 제외한 새로운 리스트로 업데이트
        setSocial((prevNews) =>
          prevNews.filter((social) => !selectedSocial.includes(social.idx))
        );
        setAllSocial((prevAllNews) =>
          prevAllNews.filter((social) => !selectedSocial.includes(social.idx))
        );
        setSelectedSocial([]); // 선택된 항목 초기화
        alert("선택한 항목이 삭제되었습니다.");
        window.location.reload();
      } else {
        alert("삭제 실패");
      }
    } catch (error) {
      console.error("삭제 중 오류 발생:", error);
      alert("삭제 중 오류가 발생했습니다.");
    }
  };

  return (
    <div>
      <ADMIN_HEADER />
      <div className="main_compo">
        <div className="path-sec">
          HOME &gt; <span className="menu1">게시판 관리</span> &gt;
          <span className="menu2"> 아소비 소셜 관리</span>
        </div>
        <table>
          <tr>
            <td>
              <div className="sec-snb">
                <h3 className="snb_tit">게시판 관리</h3>
				<ul className="snb_list">
				  {permissions.notice && (
				    <li>
				      <a href="/admin/board/notice">아소비소식 관리</a>
				    </li>
				  )}
				  {permissions.event && (
				    <li>
				      <a href="/admin/board/event">아소비이벤트 관리</a>
				    </li>
				  )}
				  {permissions.social && (
				    <li className="cur">
				      <a href="/admin/board/social">아소비 소셜 관리</a>
				    </li>
				  )}
				  {permissions.magazine && (
				    <li>
				      <a href="/admin/board/magazine">아소비 꿀지 관리</a>
				    </li>
				  )}
				</ul>
              </div>
            </td>
            <td className="right_m">
              <div className="sec-cont">
                <form name="delfrm">
                  <input type="hidden" name="mode" value="chk_del" />
                  <div className="tb_01">
                    <div className="bx_sch_btm bg_1">
                      <select
                        name="search"
                        id="search"
                        className="inputTxt"
                        value={searchOption}
                        onChange={handleSearchOptionChange}
                      >
                        <option value="title">제목</option>
                        <option value="writer_id">작성자</option>
                      </select>
                      <input
                        type="text"
                        name="strsearch"
                        id="strsearch"
                        className="inputTxt"
                        value={searchTerm}
                        onChange={handleSearchChange}
                      />
                      <button
                        className="btn info"
                        onClick={handleSearchClick} // 검색 버튼 클릭 시 동작
                      >
                        검색
                      </button>
                    </div>
                    <table>
                      <thead>
                        <tr>
                          <th>선택</th>
                          <th>번호</th>
                          <th>제목</th>
                          <th>작성자</th>
                          <th>등록일</th>
                          <th>조회수</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentSocial.length > 0 ? (
                          currentSocial.map((socials, index) => (
                            <tr key={socials.Idx}>
                              <td>
                                <input
                                  type="checkbox"
                                  onChange={(e) =>
                                    handleCheckboxChange(
                                      socials.idx,
                                      e.target.checked
                                    )
                                  }
                                />
                              </td>
                              <td>
                                {social.length - indexOfFirstSocial - index}
                              </td>
                              <td className="tit">
                                <Link to={`/admin/board/Sview/${socials.idx}`}>
                                  {socials.title}
                                </Link>
                              </td>
                              <td>{socials.name}</td>
                              <td>{formatDate(socials.regDate)}</td>
                              <td>{socials.hit}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="7" style={{ textAlign: "center" }}>
                              등록된 내용이 없습니다.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </form>
              </div>
              <div className="sec-btn-btn">
                <span className="btn custom_s">
                  <button onClick={handleDeleteSelected}>선택 삭제</button>
                </span>
                <div className="dataTables_paginate">
                  <button
                    className="paginate_button previous"
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    이전
                  </button>
                  {Array.from(
                    { length: endPage - startPage + 1 },
                    (_, index) => (
                      <button
                        key={startPage + index}
                        className={`paginate_button ${
                          currentPage === startPage + index ? "active" : ""
                        }`}
                        onClick={() => handlePageChange(startPage + index)}
                      >
                        {startPage + index}
                      </button>
                    )
                  )}
                  {endPage <= totalPages && (
                    <button
                      className="paginate_button next"
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      다음
                    </button>
                  )}
                </div>
                <span className="btn custom_r" style={{ marginRight: "20px" }}>
                  <button onClick={() => navigate("/admin/board/Swrite")}>
                    등록
                  </button>
                </span>
              </div>
            </td>
          </tr>
        </table>
      </div>
	  <ADMIN_FOOTER/>
    </div>
  );
};

export default Admin_Social;
